import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[color:var(--brand-navy-dark)] text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-8 py-14">
      <div className="grid grid-cols-12 gap-y-8 md:gap-8">
        <div className="col-span-12 md:col-span-5">
          <div className="bg-white rounded-2xl p-4 inline-block">
            <img
              src="/assets/logo.png"
              alt="MediElite Practice Solutions"
              className="h-16 w-auto"
              data-testid="footer-logo"
            />
          </div>
          <p className="mt-5 text-white/75 leading-relaxed max-w-md">
            A US healthcare consulting firm helping providers and facilities run cleaner revenue
            cycles, faster credentialing, and multi-state licensing — end to end.
          </p>
        </div>

        <div className="col-span-6 md:col-span-3">
          <h4 className="font-display text-lg mb-4">Services</h4>
          <ul className="space-y-2 text-white/75 text-sm">
            <li><a href="#rcm" className="hover:text-white">Revenue Cycle Management</a></li>
            <li><a href="#credentialing" className="hover:text-white">Credentialing</a></li>
            <li><a href="#licensing" className="hover:text-white">Provider Licensing</a></li>
            <li><a href="#bookkeeping" className="hover:text-white">Bookkeeping & Accounting</a></li>
          </ul>
        </div>

        <div className="col-span-6 md:col-span-4">
          <h4 className="font-display text-lg mb-4">Contact</h4>
          <ul className="space-y-3 text-white/85 text-sm">
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[color:var(--brand-green-200)]" />
              <a
                href="mailto:info@medielitesolutions.com"
                className="hover:text-white"
                data-testid="footer-email"
              >
                info@medielitesolutions.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[color:var(--brand-green-200)]" />
              <a href="tel:+17868915066" className="hover:text-white" data-testid="footer-phone">
                +1 786-891-5066
              </a>
            </li>
            <li className="flex items-start gap-3" data-testid="footer-address">
              <MapPin className="w-4 h-4 text-[color:var(--brand-green-200)] mt-0.5 shrink-0" />
              <span>
                971 US Highway 202 N,<br />
                Branchburg, NJ 08876
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/60">
        <p>© {new Date().getFullYear()} MediElite Practice Solutions. All rights reserved.</p>
        <div className="flex flex-wrap items-center gap-4">
          <a
            href="/privacy"
            data-testid="footer-privacy-link"
            className="text-white/80 hover:text-white underline underline-offset-2"
          >
            Privacy Policy
          </a>
          <p className="italic font-display text-sm text-[color:var(--brand-green-200)]">
            Precision That Performs.
          </p>
        </div>
      </div>
    </div>
  </footer>
);
